// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2y9jV","title":"FrontImage_title__10urm"};